(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 77183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(80255);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G_": function() { return /* binding */ threeJulianYearsBefore; },
/* harmony export */   "c0": function() { return /* binding */ preferentCycleForModel; },
/* harmony export */   "kv": function() { return /* binding */ getCyclesFromYear; }
/* harmony export */ });
function getCyclesFromYear(fromYear) {
    var cycle = [];
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getUTCMonth();
    for(var year = fromYear; year < currentYear; year++){
        var nextYear = year + 1;
        cycle.push({
            value: "".concat(year, "_").concat(nextYear),
            description: "".concat(year, "/").concat(nextYear)
        });
    }
    if (currentMonth > 5) {
        var nextYear1 = currentYear + 1;
        cycle.push({
            value: "".concat(currentYear, "_").concat(nextYear1),
            description: "".concat(currentYear, "/").concat(nextYear1)
        });
    }
    return cycle;
}
function threeJulianYearsBefore() {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getUTCMonth();
    return currentMonth > 5 ? currentYear - 3 : currentYear - 4;
}
function preferentCycleForModel() {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getUTCMonth();
    return currentMonth <= 4 ? "".concat(currentYear - 2, "_").concat(currentYear - 1) : "".concat(currentYear - 1, "_").concat(currentYear);
}


/***/ }),

/***/ 45973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getCampaignStartingOnJuly; },
/* harmony export */   "l": function() { return /* binding */ getCampaign; }
/* harmony export */ });
var getCampaign = function(date) {
    var day = date.toUTCString();
    var month = day.slice(8, 11);
    var year = day.slice(11, 16);
    var campaign = 0;
    var months = [
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        "Jan",
        "Feb",
        "Mar",
        "Apr"
    ];
    if (months.includes(month)) {
        campaign = parseInt(year) - 1;
        return "".concat(campaign, "/").concat(campaign + 1);
    } else {
        campaign = parseInt(year);
        return "".concat(campaign, "/").concat(campaign + 1);
    }
};
var getCampaignStartingOnJuly = function(date) {
    var day = date.toUTCString();
    var month = day.slice(8, 11);
    var year = day.slice(11, 16);
    var campaign = 0;
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun"
    ];
    if (months.includes(month)) {
        campaign = parseInt(year) - 1;
        return "".concat(campaign, "_").concat(campaign + 1);
    } else {
        campaign = parseInt(year);
        return "".concat(campaign, "_").concat(campaign + 1);
    }
};


/***/ }),

/***/ 43761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MX": function() { return /* binding */ rdYwGn; },
/* harmony export */   "On": function() { return /* binding */ greens2; },
/* harmony export */   "WO": function() { return /* binding */ greens; },
/* harmony export */   "ek": function() { return /* binding */ da2Yearly; },
/* harmony export */   "rq": function() { return /* binding */ esriBanana; }
/* harmony export */ });
/* unused harmony exports vegetation, viridis, magma, contours, greensThree, blues, bluesThree, alemania, alemaniaThree, carbonVegPalette, secondCarbonVegPalette, thirdCarbonVegPalette, thirdCarbonInvertedVegPalette, waterColorPalette, coverageDep1Palette, totalDep1Palette, colorArbus, colorDen, colorDes, colorHab */
var vegetation = (/* unused pure expression or super */ null && ([
    "#0d4702",
    "#3b982d",
    "#98be63",
    "#d3c653",
    "#f7c68d",
    "#ee932a",
    "#df3416",
    "#765c34",
    "#0c94e3",
    "#0cc6e3"
]));
var greens2 = [
    "#e5f6e0",
    "#c7e9c0",
    "#a1d99a",
    "#74c476",
    "#42ab5d",
    "#228b44",
    "#006d2c"
];
var viridis = (/* unused pure expression or super */ null && ([
    // '#450054',
    // '#424487',
    // '#2a788e',
    // '#20a984',
    // '#7bd251',
    // '#fde723',
    "#fde723",
    "#7bd251",
    "#20a984",
    "#2a788e",
    "#424487",
    "#450054"
]));
var magma = (/* unused pure expression or super */ null && ([
    "#000004",
    "#2C105C",
    "#711F81",
    "#B63679",
    "#EE605E",
    "#FCFDBF"
]));
var contours = (/* unused pure expression or super */ null && ([
    "#fff",
    "#000"
]));
var rdYwGn = [
    "#d7191c",
    "#fdae61",
    "#ffffc0",
    "#a6d96a",
    "#1a9641"
];
var greens = [
    "#b8d9a9",
    "#8dbd80",
    "#5d9d53",
    "#287a22",
    "#16692c"
];
var esriBanana = [
    "#beac2d",
    "#e8d966",
    "#f5e998",
    "#cfb489",
    "#ad8b62",
    "#664015"
] // dif a 20 años
;
var da2Yearly = [
    "#bc0626",
    "#f03224",
    "#fe813a",
    "#fec558",
    "#ffffac"
];
var greensThree = (/* unused pure expression or super */ null && ([
    "#b8d9a9",
    "#5d9d53",
    "#16692c"
]));
var blues = (/* unused pure expression or super */ null && ([
    "#03075e",
    "#033e8a",
    "#0177b7",
    "#0396c7",
    "#03b5d9",
    "#48cae4",
    "#92e0ef",
    "#aee7f4",
    "#c9f0f7"
]));
var bluesThree = (/* unused pure expression or super */ null && ([
    "#03075e",
    "#03b5d9",
    "#c9f0f7"
]));
var alemania = (/* unused pure expression or super */ null && ([
    "#9e0208",
    "#d10502",
    "#e95d04",
    "#f48b08",
    "#fb8f07",
    "#fba307",
    "#ffba0b",
    "#ffe30b",
    "#fff70b"
]));
var alemaniaThree = (/* unused pure expression or super */ null && ([
    "#02071d",
    "#d10502",
    "#ffba0b"
]));
var carbonVegPalette = (/* unused pure expression or super */ null && ([
    "#ffffc7",
    "#ddc88f",
    "#b9935a",
    "#82612d",
    "#4e3300"
]));
var secondCarbonVegPalette = (/* unused pure expression or super */ null && ([
    "#A4DE02",
    "#76BA1B",
    "#4C9A2A",
    "#ACDF87",
    "#68BB59"
]));
var thirdCarbonVegPalette = (/* unused pure expression or super */ null && ([
    "#41C0F2",
    "#58c7F3",
    "#70CFF5",
    "#A0DFF8",
    "#CFEFFC"
]));
var thirdCarbonInvertedVegPalette = (/* unused pure expression or super */ null && ([
    "#CFEFFC",
    "#A0DFF8",
    "#70CFF5",
    "#58c7F3",
    "#41C0F2"
]));
var waterColorPalette = (/* unused pure expression or super */ null && ([
    "#f3e3d2",
    "#c8c39e",
    "#2196f3",
    "#137fd9",
    "#0069c0"
]));
var coverageDep1Palette = (/* unused pure expression or super */ null && ([
    "#f5e1ce",
    "#e8c39e",
    "#5ccb5f",
    "#009929",
    "#006414"
]));
var totalDep1Palette = (/* unused pure expression or super */ null && ([
    "#ffff8b",
    "#c6da52",
    "#8db600",
    "#588100",
    "#255000"
]));
var colorArbus = (/* unused pure expression or super */ null && ([
    "#FFFFFF05",
    "#ffaf7a",
    "#ff9d5c",
    "#ff8b3d",
    "#ff781f"
]));
var colorDen = (/* unused pure expression or super */ null && ([
    "#FFFFFF05",
    "#e1affd",
    "#ca8dfd",
    "#c175ff",
    "#b042ff"
]));
var colorDes = (/* unused pure expression or super */ null && ([
    "#FFFFFF05",
    "#BFDAD7",
    "#A0C8C3",
    "#7AB4AD",
    "#1C9997"
]));
var colorHab = (/* unused pure expression or super */ null && ([
    "#FFFFFF05",
    "#DBE4A9",
    "#C3D48B",
    "#95B634",
    "#8AAD34"
]));


/***/ }),

/***/ 23547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ numberFormatAsked; }
/* harmony export */ });
var numberFormatAsked = function(number) {
    if (number === null || number === undefined) {
        return "0,00";
    }
    if (Number.isInteger(number)) {
        return number.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replaceAll(",", ".").replace(":", ",");
    }
    return number.toFixed(2).toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replaceAll(",", ".").replace(":", ",");
};


/***/ }),

/***/ 80255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(88304);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./src/store/slices/operationUnitSlice.ts + 1 modules
var operationUnitSlice = __webpack_require__(85036);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js
var Card = __webpack_require__(54278);
// EXTERNAL MODULE: ./node_modules/chart.js/auto/auto.js
var auto = __webpack_require__(9085);
// EXTERNAL MODULE: ./node_modules/chart.js/dist/chart.js
var chart = __webpack_require__(23148);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.js
var dist = __webpack_require__(26495);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(59677);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(81138);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js
var Button = __webpack_require__(56798);
// EXTERNAL MODULE: ./src/@core/layouts/components/Translations.tsx
var Translations = __webpack_require__(67297);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@types/index.ts
var _types = __webpack_require__(78726);
;// CONCATENATED MODULE: ./src/views/rain/rains-empty-card/index.tsx









function RainsEmptyCard(param) {
    var landId = param.landId, status = param.status;
    var router = (0,next_router.useRouter)();
    var handleRedirectToRains = function() {
        router.push("/lands/details/rains/".concat(landId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rains-card",
        sx: {
            minWidth: "250px",
            height: "260px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "#D9D9D9",
            paddingTop: "45px",
            paddingBottom: "45px",
            paddingRight: "13px",
            paddingLeft: "13px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    margin: "auto",
                    width: "270px",
                    height: "120px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "clamp(16px, 10px, 25px)",
                            fontWeight: "700",
                            textAlign: "center",
                            color: "rgb(120 120 120)",
                            mb: 5
                        },
                        className: "cards-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "You haven't uploaded your rainfall history yet"
                        })
                    }),
                    status === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            w: "100%",
                            alignItems: "center",
                            mt: "24px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            sx: {
                                color: "#213D36",
                                width: "123px",
                                padding: "8px, 12px, 8px, 12px",
                                fontSize: "16px",
                                fontWeight: 700,
                                borderRadius: "30px",
                                border: "3px solid #213D36",
                                backgroundColor: "white"
                            },
                            onClick: handleRedirectToRains,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Load"
                            })
                        })
                    }) : null
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/rain/rains-card/index.tsx












auto/* Chart.register */.kL.register(chart/* BarController */.vn, chart/* Tooltip */.u);
function RainsCard(param) {
    var landId = param.landId, information = param.information, status = param.status;
    var ref;
    var router = (0,next_router.useRouter)();
    var monthName = new Intl.DateTimeFormat("en-US", {
        month: "long"
    }).format(new Date());
    var colors = [
        "#CAAA70",
        "#526378"
    ];
    var handleRedirectToRains = function() {
        router.push("/lands/details/rains/".concat(landId));
    };
    var labels = [];
    if (information) {
        var ref1;
        labels = [
            "".concat(information.actualAcumulatedRain.toFixed(0), " mm"),
            "".concat((information === null || information === void 0 ? void 0 : (ref1 = information.averageAcumulatedRain) === null || ref1 === void 0 ? void 0 : ref1.toFixed(0)) || 0, " mm")
        ];
    }
    return information ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rains-card",
        sx: {
            minWidth: "250px",
            height: "260px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center"
                            },
                            className: "cards-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Rain historic"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "black",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: monthName
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-evenly"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                        text: "Actual"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                        text: "accumulated"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        textAlign: "center",
                                        color: "#CAAA70"
                                    },
                                    children: information.actualAcumulatedRain.toFixed(0) + "mm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: "100px%",
                                minHeight: "100px",
                                maxWidth: "100px",
                                maxHeight: "100px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
                                data: {
                                    labels: labels,
                                    datasets: [
                                        {
                                            data: [
                                                information.actualAcumulatedRain,
                                                information.averageAcumulatedRain
                                            ],
                                            backgroundColor: colors,
                                            borderColor: colors,
                                            barThickness: 15,
                                            borderSkipped: false
                                        }
                                    ]
                                },
                                options: {
                                    color: "black",
                                    responsive: true,
                                    plugins: {
                                        legend: {
                                            display: false,
                                            labels: {
                                                font: {
                                                    size: 5
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        x: {
                                            display: false,
                                            border: {
                                                display: false
                                            },
                                            ticks: {
                                                color: "black"
                                            }
                                        },
                                        y: {
                                            display: false,
                                            beginAtZero: true,
                                            ticks: {
                                                display: false
                                            },
                                            border: {
                                                display: false
                                            }
                                        }
                                    }
                                },
                                width: "70px",
                                height: "100px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                        text: "Average"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                        text: "accumulated"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        textAlign: "center",
                                        color: "#526378"
                                    },
                                    children: (information === null || information === void 0 ? void 0 : (ref = information.averageAcumulatedRain) === null || ref === void 0 ? void 0 : ref.toFixed(0)) + "mm"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36"
                        },
                        onClick: handleRedirectToRains,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "DETAILS"
                        })
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RainsEmptyCard, {
        landId: landId,
        status: status
    });
};

// EXTERNAL MODULE: ./node_modules/react-material-ui-carousel/dist/index.js
var react_material_ui_carousel_dist = __webpack_require__(13056);
var dist_default = /*#__PURE__*/__webpack_require__.n(react_material_ui_carousel_dist);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropUp.js
var ArrowDropUp = __webpack_require__(29217);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(45111);
;// CONCATENATED MODULE: ./src/views/rodeos/rodeo-empty-card/index.tsx









function RodeoEmptyCard(param) {
    var landId = param.landId, status = param.status;
    var router = (0,next_router.useRouter)();
    var handleRedirectRodeo = function() {
        return router.push("/lands/details/rodeos/".concat(landId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rodeos-card",
        sx: {
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "#D9D9D9",
            paddingTop: "45px",
            paddingBottom: "45px",
            minWidth: "250px",
            height: "495px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "18px",
                            fontWeight: "700",
                            textAlign: "center",
                            color: "rgb(120 120 120)",
                            mb: 5
                        },
                        className: "cards-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "You haven't created your rodeos yet"
                        })
                    }),
                    status === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            w: "100%",
                            alignItems: "center",
                            mt: "24px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            sx: {
                                color: "#213D36",
                                width: "123px",
                                padding: "8px, 12px, 8px, 12px",
                                fontSize: "16px",
                                fontWeight: 700,
                                borderRadius: "30px",
                                border: "3px solid #213D36",
                                backgroundColor: "white"
                            },
                            onClick: handleRedirectRodeo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Load"
                            })
                        })
                    }) : null
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/rodeos/rodeo-card/index.tsx












function RodeoCard(param) {
    var information = param.information, landId = param.landId, status = param.status;
    var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
        var stringWithSpaces = str.replace(/_/g, " ");
        var parts = stringWithSpaces.match(/(.*?)(\d+.*)?$/);
        if (parts) {
            var textPart = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase().trim();
            var numberPart = parts[2] ? parts[2].replace(/ /g, "-") : "";
            return textPart + (numberPart ? " " + numberPart : "");
        }
        return str;
    };
    var calculateFinalNumber = function calculateFinalNumber(differentCategories) {
        var finalNumber = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = differentCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var category = _step.value;
                finalNumber += category.newHeads || 0;
                finalNumber -= category.minusHeads || 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return finalNumber;
    };
    var router = (0,next_router.useRouter)();
    var groupedItems = [];
    if (information === null || information === void 0 ? void 0 : information.differentCategories) {
        var ref;
        for(var i = 0; i < (information === null || information === void 0 ? void 0 : (ref = information.differentCategories) === null || ref === void 0 ? void 0 : ref.length); i += 3){
            groupedItems.push(information.differentCategories.slice(i, i + 3));
        }
    }
    var handleRedirectRodeo = function() {
        return router.push("/lands/details/rodeos/".concat(landId));
    };
    var finalNumber = 0;
    if (information === null || information === void 0 ? void 0 : information.differentCategories) {
        finalNumber = calculateFinalNumber(information.differentCategories);
    }
    if (!information || information.totalHeads === undefined || information.differentCategories === undefined || information.totalHeads === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RodeoEmptyCard, {
        landId: landId,
        status: status
    });
    return information && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rodeos-card",
        sx: {
            width: "100%",
            height: "495px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white !important"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center",
                                mb: "24px"
                            },
                            className: "cards-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Rodeos"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                width: "100%",
                                textAlign: "center",
                                mb: "24px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "black",
                                        fontWeight: "700",
                                        fontSize: "40px",
                                        pr: 2
                                    },
                                    children: information.totalHeads.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                }),
                                finalNumber === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : finalNumber > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                                            sx: {
                                                verticalAlign: "middle",
                                                color: "green"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "green",
                                                fontWeight: "800",
                                                textAlign: "center",
                                                fontSize: "18px",
                                                left: -5
                                            },
                                            children: finalNumber.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                                            sx: {
                                                verticalAlign: "middle",
                                                color: "red"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "red",
                                                fontWeight: "800",
                                                textAlign: "center",
                                                fontSize: "18px",
                                                left: -5
                                            },
                                            children: finalNumber * -1..toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        mb: "24px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontWeight: "600",
                                fontSize: "18px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Heads"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontWeight: "600",
                                fontSize: "18px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Categories"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    height: 170,
                    autoPlay: false,
                    animation: "slide",
                    indicators: true,
                    navButtonsAlwaysVisible: true,
                    fullHeightHover: false,
                    navButtonsProps: {
                        style: {
                            display: "none",
                            backgroundColor: "transparent",
                            borderRadius: 0
                        }
                    },
                    children: groupedItems.map(function(group, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: group.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        borderRadius: "15px",
                                        backgroundColor: "".concat(item.newHeads && item.minusHeads && item.newHeads > item.minusHeads ? "rgba(40, 154, 56, 0.13)" : item.newHeads && item.minusHeads && item.newHeads < item.minusHeads ? "rgba(255, 46, 46, 0.16)" : "rgba(0, 0, 0, 0.1)"),
                                        mb: "24px",
                                        height: "40px",
                                        paddingLeft: "20px",
                                        paddingRight: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                flexDirection: "row"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        color: "black",
                                                        fontWeight: "600",
                                                        fontSize: "18px"
                                                    },
                                                    children: item.headCount.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                                }),
                                                item.newHeads && item.minusHeads && item.newHeads > item.minusHeads && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                                                            sx: {
                                                                verticalAlign: "middle",
                                                                color: "green"
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                color: "green",
                                                                fontWeight: "800",
                                                                textAlign: "center",
                                                                fontSize: "clamp(8px, 16px, 20px)",
                                                                left: -5
                                                            },
                                                            children: (item.newHeads - item.minusHeads).toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                                        })
                                                    ]
                                                }),
                                                item.newHeads && item.minusHeads && item.newHeads < item.minusHeads && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                                                            sx: {
                                                                verticalAlign: "middle",
                                                                color: "red"
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                color: "red",
                                                                fontWeight: "800",
                                                                textAlign: "center",
                                                                fontSize: "clamp(8px, 16px, 20px)",
                                                                left: -5
                                                            },
                                                            children: (item.minusHeads + item.newHeads).toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                                        })
                                                    ]
                                                }),
                                                item.newHeads && !item.minusHeads && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                                                            sx: {
                                                                verticalAlign: "middle",
                                                                color: "green"
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                color: "green",
                                                                fontWeight: "800",
                                                                textAlign: "center",
                                                                fontSize: "clamp(8px, 16px, 20px)",
                                                                left: -5
                                                            },
                                                            children: item.newHeads.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                                        })
                                                    ]
                                                }),
                                                item.minusHeads && !item.newHeads && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                                                            sx: {
                                                                verticalAlign: "middle",
                                                                color: "red"
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                color: "red",
                                                                fontWeight: "800",
                                                                textAlign: "center",
                                                                fontSize: "clamp(8px, 16px, 20px)",
                                                                left: -5
                                                            },
                                                            children: item.minusHeads.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",").replace(".", ":").replace(",", ".").replace(":", ",")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "black",
                                                fontSize: "clamp(10px, 14px, 18px)",
                                                textAlign: "end",
                                                ml: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                text: capitalizeFirstLetter(item.category)
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36"
                        },
                        onClick: handleRedirectRodeo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "DETAILS"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardMedia/CardMedia.js
var CardMedia = __webpack_require__(72213);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/@core/hooks/useWeatherCondition.tsx




function useWeatherCall(city) {
    var ref = (0,react.useState)(undefined), values = ref[0], setValues = ref[1];
    (0,react.useEffect)(function() {
        var call = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, suggestion;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return axios_default().get("https://api.weatherapi.com/v1/current.json?q=".concat(city, "&lang=Es&key=").concat("c42cb9eb48044c338a7154531231807"));
                        case 3:
                            ref = _ctx.sent;
                            suggestion = ref.data;
                            setValues(suggestion);
                            _ctx.next = 12;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("Error fetching data, ", _ctx.t0);
                            setValues(null);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function call() {
                return _ref.apply(this, arguments);
            };
        }();
        call();
    }, [
        city
    ]);
    return values;
}
/* harmony default export */ var useWeatherCondition = (useWeatherCall);

// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 5 modules
var i18next = __webpack_require__(34853);
;// CONCATENATED MODULE: ./src/views/weatherCard/index.tsx










function WeatherCard(param) {
    var city = param.city;
    var ref, ref1;
    var weatherInfo = useWeatherCondition(city);
    var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    if (weatherInfo === undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            variant: "rectangular",
            className: "weather-card",
            sx: {
                width: "100%",
                height: "260px",
                alignItems: "center",
                borderRadius: "20px"
            }
        });
    }
    if (weatherInfo === null) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "weather-card",
        sx: {
            minWidth: "250px",
            alignSelf: "center",
            justifySelf: "center",
            height: "260px",
            width: "100%",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white !important"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            mb: "12px",
                            padding: "12px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "60px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                                    component: "img",
                                    src: weatherInfo === null || weatherInfo === void 0 ? void 0 : (ref = weatherInfo.current) === null || ref === void 0 ? void 0 : (ref1 = ref.condition) === null || ref1 === void 0 ? void 0 : ref1.icon,
                                    alt: "weather"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "auto",
                                    textAlign: "center",
                                    letterSpacing: "0.28px",
                                    lineHeight: "normal"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            fontWeight: "400",
                                            color: "#B0B0B4",
                                            fontSize: "14px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: new Date().getUTCDate().toString() + (0,i18next.t)(" ".concat(monthNames[new Date().getMonth()], " ")) + new Date().getFullYear().toString()
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            fontWeight: "400",
                                            color: "black",
                                            fontSize: "16px",
                                            letterSpacing: "-0.36px",
                                            lineHeight: "15px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: weatherInfo.current.condition.text
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.primary",
                                    sx: {
                                        fontSize: "30px",
                                        fontWeight: "700",
                                        color: "black",
                                        ml: 2
                                    },
                                    children: weatherInfo.current.temp_c + "\xb0"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            height: "115px",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "flex-start",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "auto",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "./Precipitaciones.png",
                                        alt: "humidity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            color: "#B5B5B9",
                                            fontSize: "14px",
                                            mt: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Humidity"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            color: "black",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            mt: 1
                                        },
                                        children: weatherInfo.current.humidity + "%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "auto",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "./Lluvias.png",
                                        alt: "humidity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            color: "#B5B5B9",
                                            fontSize: "14px",
                                            mt: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Precipitations"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            color: "black",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            mt: 1
                                        },
                                        children: weatherInfo.current.precip_mm + " mm"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "auto",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "./Viento.png",
                                        alt: "humidity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            color: "#B5B5B9",
                                            fontSize: "14px",
                                            mt: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Wind"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            color: "black",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            mt: 1
                                        },
                                        children: weatherInfo.current.wind_kph + " Km/h"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(90149);
;// CONCATENATED MODULE: ./src/views/dashboard/utils/index.tsx






function CircularProgressWithLabel(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            position: "relative",
            display: "inline-flex",
            height: "150px",
            width: "140px"
        },
        className: "circulo-porcentaje",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, (0,_object_spread/* default */.Z)({
                    sx: {
                        color: "rgb(0,80,48)"
                    },
                    size: 120,
                    thickness: 2,
                    variant: "determinate"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        component: "div",
                        sx: {
                            color: "rgb(0,80,48)",
                            fontWeight: "700",
                            fontSize: "40px"
                        },
                        children: "".concat(Math.round(props.value), "%")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RemoveCircleOutline.js
var RemoveCircleOutline = __webpack_require__(49829);
;// CONCATENATED MODULE: ./src/views/dashboard/load-card/index.tsx












function LoadCard(param) {
    var land = param.land;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), percentage = ref[0], setPercentage = ref[1];
    var router = (0,next_router.useRouter)();
    react.useEffect(function() {
        if (land.state === _types/* LandState.DRAFT_FIELDS */.oU.DRAFT_FIELDS) {
            setPercentage(25);
        } else if (land.state === _types/* LandState.DRAFT_PLUVIOMETERS */.oU.DRAFT_PLUVIOMETERS) {
            setPercentage(50);
        } else if (land.state === _types/* LandState.DRAFT_WATER_TROUGHS */.oU.DRAFT_WATER_TROUGHS) {
            setPercentage(75);
        } else if (land.state === _types/* LandState.COMPLETED */.oU.COMPLETED) {
            setPercentage(100);
        }
    }, [
        land.state
    ]);
    var handleClick = function() {
        var ref;
        if (land.state !== _types/* LandState.COMPLETED */.oU.COMPLETED) router.push("/create-land/".concat((ref = land.operationUnit) === null || ref === void 0 ? void 0 : ref.id, "?landId=").concat(land.id));
        if (land.state === _types/* LandState.COMPLETED */.oU.COMPLETED) router.push("/lands/details/land/".concat(land.id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "load-card",
        sx: {
            minWidth: "250px",
            height: "260px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "black",
                            textAlign: "center"
                        },
                        className: "cards-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "Data upload"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "steps-del-campo",
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            height: "145px",
                            justifyContent: "space-around",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressWithLabel, {
                                value: percentage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "45%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            land.state === _types/* LandState.DRAFT_FIELDS */.oU.DRAFT_FIELDS || land.state === _types/* LandState.DRAFT_PLUVIOMETERS */.oU.DRAFT_PLUVIOMETERS || land.state === _types/* LandState.DRAFT_WATER_TROUGHS */.oU.DRAFT_WATER_TROUGHS || land.state === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                                                sx: {
                                                    color: "#213D36",
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCircleOutline/* default */.Z, {
                                                sx: {
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    fontWeight: "400",
                                                    m: 1,
                                                    color: "black"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: "Land"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            land.state === _types/* LandState.DRAFT_PLUVIOMETERS */.oU.DRAFT_PLUVIOMETERS || land.state === _types/* LandState.DRAFT_WATER_TROUGHS */.oU.DRAFT_WATER_TROUGHS || land.state === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                                                sx: {
                                                    color: "#213D36",
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCircleOutline/* default */.Z, {
                                                sx: {
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    fontWeight: "400",
                                                    m: 1,
                                                    color: "black"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: "Field"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            land.state === _types/* LandState.DRAFT_WATER_TROUGHS */.oU.DRAFT_WATER_TROUGHS || land.state === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                                                sx: {
                                                    color: "#213D36",
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCircleOutline/* default */.Z, {
                                                sx: {
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    fontWeight: "400",
                                                    m: 1,
                                                    color: "black"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: "Pluviometers"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            land.state === _types/* LandState.COMPLETED */.oU.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                                                sx: {
                                                    color: "#213D36",
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCircleOutline/* default */.Z, {
                                                sx: {
                                                    fontSize: "16px",
                                                    mr: "14px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    fontWeight: "400",
                                                    m: 1,
                                                    color: "black"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: "Water troughs"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            w: "100%",
                            alignItems: "center",
                            mt: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            sx: {
                                color: "#213D36",
                                width: "123px",
                                padding: "8px, 12px, 8px, 12px",
                                fontSize: "16px",
                                fontWeight: 700,
                                borderRadius: "30px",
                                border: "3px solid #213D36",
                                mt: "auto"
                            },
                            onClick: handleClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "".concat(land.state === _types/* LandState.COMPLETED */.oU.COMPLETED ? "DETAILS" : "UPLOAD")
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@reactour/tour/dist/index.mjs
var tour_dist = __webpack_require__(37901);
// EXTERNAL MODULE: ./src/store/slices/userSlice.ts + 1 modules
var userSlice = __webpack_require__(85102);
// EXTERNAL MODULE: ./src/@core/hooks/useFirebaseAuth.tsx + 13 modules
var useFirebaseAuth = __webpack_require__(1363);
// EXTERNAL MODULE: ./src/views/reports/gradient-box.tsx
var gradient_box = __webpack_require__(91142);
// EXTERNAL MODULE: ./src/@core/utils/gradients.ts
var gradients = __webpack_require__(43761);
;// CONCATENATED MODULE: ./src/views/dashboard/card-dp5/card-dp5.tsx











function CardDp5(param) {
    var percentage = param.percentage, landId = param.landId;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "dp5-card",
        sx: {
            minWidth: "250px",
            height: "260px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                minWidth: "250px",
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "black",
                            textAlign: "center"
                        },
                        className: "cards-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "Productive capacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "steps-del-campo",
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "145px",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_box/* default */.Z, {
                                        colors: gradients/* rdYwGn */.MX,
                                        tall: "15px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            width: "90%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                                            sx: {
                                                verticalAlign: "middle",
                                                color: "black",
                                                marginLeft: "".concat(percentage * 90, "%")
                                            },
                                            fontSize: "large"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    fontSize: "40px",
                                    fontWeight: 700,
                                    color: "black"
                                },
                                children: "".concat((percentage * 100).toFixed(0), " %")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            w: "100%",
                            alignItems: "center",
                            mt: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            sx: {
                                color: "#213D36",
                                width: "auto",
                                padding: "8px, 12px, 8px, 12px",
                                fontSize: "16px",
                                fontWeight: 700,
                                borderRadius: "30px",
                                border: "3px solid #213D36",
                                mt: "auto"
                            },
                            onClick: function() {
                                return router.push("/models/".concat(landId));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "See report"
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/store/slices/reportSlice.ts
var reportSlice = __webpack_require__(13675);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(16647);
// EXTERNAL MODULE: ./src/@core/utils/get-campaign.ts
var get_campaign = __webpack_require__(45973);
;// CONCATENATED MODULE: ./src/views/dashboard/grass-growth/index.tsx












var GrassGrowth = function(param) {
    var pastureGrowth = param.pastureGrowth, landId = param.landId;
    var labels = [
        (0,i18next.t)("Jul"),
        (0,i18next.t)("Aug"),
        (0,i18next.t)("Sep"),
        (0,i18next.t)("Oct"),
        (0,i18next.t)("Nov"),
        (0,i18next.t)("Dec"),
        (0,i18next.t)("Jan"),
        (0,i18next.t)("Feb"),
        (0,i18next.t)("Mar"),
        (0,i18next.t)("Apr"),
        (0,i18next.t)("May"),
        (0,i18next.t)("Jun")
    ];
    var averageData = pastureGrowth.filter(function(element) {
        return element.pastureDataType === "tc_mean";
    }).sort(function(a, b) {
        if (labels.indexOf((0,i18next.t)(a.month)) > labels.indexOf((0,i18next.t)(b.month))) return 1;
        else return -1;
    });
    var currentData = pastureGrowth.filter(function(element) {
        return element.pastureDataType === "tc_mean_ultimo_cicle";
    }).sort(function(a, b) {
        if (labels.indexOf((0,i18next.t)(a.month)) > labels.indexOf((0,i18next.t)(b.month))) return 1;
        else return -1;
    });
    var dpDate = (0,es/* useSelector */.v9)(function(state) {
        return state.report.checkDpDate;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var servingsHarvestable = "".concat(landId, "%2F").concat(new Date().getFullYear() - 1, "_").concat(new Date().getFullYear(), "%2FSERVINGS_HARVESTABLE_RASTER.tif");
    (0,react.useEffect)(function() {
        dispatch((0,reportSlice/* fetchDateOfModel */.cz)(servingsHarvestable));
    }, [
        servingsHarvestable
    ]);
    var data = {
        labels: labels,
        datasets: [
            {
                label: (0,i18next.t)("Average last 5 years"),
                backgroundColor: "#D9D9D9",
                borderColor: "#D9D9D9",
                data: averageData.map(function(month) {
                    return month.pasture;
                })
            },
            {
                label: dpDate ? (0,get_campaign/* getCampaign */.l)(new Date(dpDate)) : " ",
                borderColor: "#005030",
                backgroundColor: "#005030",
                data: currentData.map(function(month) {
                    return month.pasture;
                })
            }
        ]
    };
    var options = {
        plugins: {
            legend: {
                labels: {
                    color: "#5B5B98"
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            sx: {
                height: "495px",
                boxShadow: "none",
                borderRadius: "20px",
                padding: "20px",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        fontSize: "13px !important",
                        fontWeight: 400,
                        display: "flex",
                        color: "black",
                        justifyContent: "center",
                        transform: "rotate(90deg)  rotate(180deg)",
                        position: "absolute",
                        marginTop: "27%",
                        marginLeft: "-80px"
                    },
                    className: "cards-title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                        text: "Growth rate (kgMS/ha/month)"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mt: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingBottom: "10px"
                    },
                    className: "for-dark-bottom-border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        sx: {
                            fontSize: "18px !important",
                            fontWeight: 700
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "Grass growth chart"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        ml: "8%",
                        width: "93%",
                        height: "85%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Line */.x1, {
                            data: data,
                            options: options,
                            height: 180
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                mt: 3,
                                fontSize: "15px !important",
                                fontWeight: 400,
                                width: "96%",
                                display: "flex",
                                color: "black",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Mes"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var grass_growth = (GrassGrowth);

// EXTERNAL MODULE: ./src/store/slices/dashboard-slice.ts + 1 modules
var dashboard_slice = __webpack_require__(88759);
// EXTERNAL MODULE: ./src/@core/utils/number-format-asked.ts
var number_format_asked = __webpack_require__(23547);
;// CONCATENATED MODULE: ./src/views/dashboard/emission-card/index.tsx









function EmissionsCard(param) {
    var kgCO2EqPV = param.kgCO2EqPV, totalCO2eq = param.totalCO2eq, totalCO2EqPerHead = param.totalCO2EqPerHead, kgCO2Ha = param.kgCO2Ha, landId = param.landId, cycle = param.cycle;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rodeos-card",
        sx: {
            minWidth: "250px",
            height: "495px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white !important"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center"
                            },
                            className: "cards-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Emission"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#222",
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: 400,
                                letterSpacing: "-0.28px",
                                mb: "24px"
                            },
                            children: cycle.replace("_", "/")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                textAlign: "center",
                                mb: "30px",
                                padding: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "black",
                                        fontWeight: "700",
                                        fontSize: "40px",
                                        pr: 2
                                    },
                                    children: (0,number_format_asked/* numberFormatAsked */.I)(kgCO2EqPV)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "black",
                                                fontWeight: "500",
                                                fontSize: "18px",
                                                pr: 2
                                            },
                                            children: "kgCO2eq/kg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "black",
                                                fontWeight: "700",
                                                fontSize: "12px",
                                                pr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                text: "PV produced"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Total CO2 eq"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(totalCO2eq)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Total CO2 eq per EV (Kg)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: totalCO2EqPerHead && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(totalCO2EqPerHead)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Kg CO2 eq/ha"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(kgCO2Ha)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36",
                            mt: "auto"
                        },
                        onClick: function() {
                            return router.push("/lands/details/land/".concat(landId));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "See more"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/views/dashboard/card-production/index.tsx










function getGradient(chart) {
    var ctx = chart.ctx, _chartArea = chart.chartArea, left = _chartArea.left, right = _chartArea.right;
    var gradientSegment = ctx.createLinearGradient(left, 0, right, 0);
    gradientSegment.addColorStop(0, "red");
    gradientSegment.addColorStop(0.5, "yellow");
    gradientSegment.addColorStop(1, "green");
    return gradientSegment;
}
var ProductionCard = function(param) {
    var detailedLoad = param.detailedLoad, landId = param.landId, status = param.status;
    var router = (0,next_router.useRouter)();
    var data = {
        labels: [],
        datasets: [
            {
                labels: (0,i18next.t)("Average"),
                backgroundColor: function(context) {
                    var chart = context.chart;
                    var chartArea = chart.chartArea;
                    if (!chartArea) {
                        return null;
                    }
                    if (context.dataIndex === 0) {
                        return getGradient(chart);
                    } else {
                        return "black";
                    }
                },
                borderColor: "transparent",
                borderRadius: 20,
                data: [
                    detailedLoad.grADPV
                ],
                cutout: "85%",
                circumference: 180,
                rotation: 270,
                needleValue: detailedLoad.grADPV < 200 ? 1 : detailedLoad.grADPV > 500 ? 300 : detailedLoad.grADPV - 200
            }
        ]
    };
    var gaugeNeedle = {
        id: "gaugeNeedle",
        afterDatasetDraw: function afterDatasetDraw(chart) {
            var ctx = chart.ctx, data = chart.data, width = chart.chartArea.width;
            ctx.save();
            var needleValue = data.datasets[0].needleValue;
            var dataTotal = 500 - 200;
            var angle = Math.PI + 1 / dataTotal * needleValue * Math.PI;
            var cx = width / 2;
            var cy = chart._metasets[0].data[0].y;
            ctx.lineWidth = 2;
            ctx.translate(cx, cy);
            ctx.rotate(angle);
            ctx.beginPath();
            ctx.strokeStyle = "black";
            ctx.moveTo(1, 1);
            ctx.lineTo(85, 0);
            ctx.stroke();
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.strokeStyle = "white";
            ctx.moveTo(1, 1);
            ctx.lineTo(60, 0);
            ctx.stroke();
            ctx.translate(-cx, -cy);
            ctx.beginPath();
            ctx.arc(cx, cy, 1, 0, 2);
            ctx.fillStyle = "transparent";
            ctx.restore();
            ctx.font = "18px sans-serif";
            ctx.textAlign = "center";
            ctx.textBaseLine = "bottom";
            ctx.fillText("Gr ADPV", cx, cy - 10);
        }
    };
    var config = {
        type: "doughnut",
        data: data,
        options: {
            responsive: false,
            borderRadius: "20px",
            aspectRatio: 1.5,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            sx: {
                height: "495px",
                boxShadow: "none",
                borderRadius: "20px",
                padding: "20px",
                position: "relative",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        mt: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingBottom: "10px"
                    },
                    className: "for-dark-bottom-border",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            sx: {
                                fontSize: "18px !important",
                                fontWeight: 700
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Production"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#222",
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: 400,
                                letterSpacing: "-0.28px"
                            },
                            children: detailedLoad.cycle.replace("_", "/")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        mb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: "90%",
                                mt: "30%",
                                pb: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "absolute"
                            },
                            className: "for-dark-bottom-border",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                sx: {
                                    fontSize: "24px !important",
                                    fontWeight: 700,
                                    color: "black"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(detailedLoad.grADPV)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "12px !important",
                                fontWeight: 600,
                                mb: "10%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "200"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-start",
                                minWidth: "165px",
                                minHeight: "165px",
                                maxWidth: "165px",
                                maxHeight: "165px",
                                ml: 5,
                                mr: 5,
                                mt: -5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Doughnut */.$I, {
                                data: data,
                                options: config,
                                height: 82,
                                plugins: [
                                    gaugeNeedle
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "12px !important",
                                fontWeight: 600,
                                mb: "10%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    backgroundColor: "#E8DAC1",
                                    borderRadius: "15px",
                                    padding: "8px 20px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Meat (Kg)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 700,
                                            fontSize: "16px"
                                        },
                                        children: (0,number_format_asked/* numberFormatAsked */.I)(detailedLoad.totalProduction)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    backgroundColor: "#E8DAC1",
                                    borderRadius: "15px",
                                    padding: "8px 20px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Meat per head (Kg)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 700,
                                            fontSize: "16px"
                                        },
                                        children: (0,number_format_asked/* numberFormatAsked */.I)(detailedLoad.productionPerHead)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    backgroundColor: "#E8DAC1",
                                    borderRadius: "15px",
                                    padding: "8px 20px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Meat per livestock ha (Kg)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: 700,
                                            fontSize: "16px"
                                        },
                                        children: (0,number_format_asked/* numberFormatAsked */.I)(detailedLoad.productionPerArea)
                                    })
                                ]
                            })
                        ]
                    })
                }),
                status && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36"
                        },
                        onClick: function() {
                            return router.push("/lands/details/rodeos/".concat(landId));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "See more"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var card_production = (ProductionCard);

// EXTERNAL MODULE: ./src/store/slices/dp9-da1.ts + 1 modules
var dp9_da1 = __webpack_require__(90466);
;// CONCATENATED MODULE: ./src/views/dashboard/card-carga/index.tsx











function CardCarga(param) {
    var landId = param.landId, data = param.data;
    var ref;
    var router = (0,next_router.useRouter)();
    var colors = [
        "#FF0404",
        "#FAFF0A",
        "#25B522",
        "#FAFF0A",
        "#FF0404"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rodeos-card",
        sx: {
            minWidth: "250px",
            height: "495px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white !important"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center",
                                mb: 4
                            },
                            className: "cards-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Stock"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#222",
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: 400,
                                letterSpacing: "-0.28px",
                                mb: 2
                            },
                            children: (ref = data.cycle) === null || ref === void 0 ? void 0 : ref.replace("_", "/")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mt: "24px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_box/* default */.Z, {
                                    colors: colors,
                                    tall: "15px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        width: "90%",
                                        justifyContent: "flex-start",
                                        display: "flex"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                                        sx: {
                                            verticalAlign: "middle",
                                            color: "black",
                                            marginLeft: "".concat(data.load * 0.9 / 2, "%")
                                        },
                                        fontSize: "large"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "40px",
                                fontWeight: 700,
                                color: "black",
                                textAlign: "center"
                            },
                            children: "".concat(data.load, " %")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "EV current stock"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(data.actualEv)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Potential production"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(data.potentialProduction)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "15px",
                        backgroundColor: "rgba(25, 118, 210, 0.20)",
                        mt: "24px",
                        height: "40px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Potential EV"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(data.potentialEv)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "auto",
                        marginTop: "10px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36",
                            mt: "auto"
                        },
                        onClick: function() {
                            return router.push("/lands/details/rodeos/".concat(landId));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "See more"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(72347);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
;// CONCATENATED MODULE: ./src/views/dashboard/card-auditoria/index.tsx






var CardAuditoria = function(param) {
    var auditingData = param.auditingData;
    var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
        if (str) {
            return str.slice(0, 1).toUpperCase() + str.slice(1);
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref55, ref56, ref57;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (auditingData === null || auditingData === void 0 ? void 0 : (ref = auditingData.data) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
                height: "495px",
                boxShadow: "none",
                padding: "20px",
                position: "relative",
                display: "flex",
                alignItems: "center",
                borderRadius: "20px",
                backgroundColor: "white !important"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "black",
                            textAlign: "center"
                        },
                        className: "cards-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "Latest tasks"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "14px",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Last task was "
                            }),
                            auditingData.lastTask,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: " days ago"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-around",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    height: "80px",
                                    backgroundColor: "#F1E9DB",
                                    borderRadius: "12px",
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    columns: 5,
                                    sx: {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "15px",
                                        width: "97%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    gap: 3,
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: (ref1 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.name) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 1).toUpperCase()
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        children: ((ref3 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref3 === void 0 ? void 0 : ref3.name.length) > 8 ? ((ref4 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref4 === void 0 ? void 0 : ref4.name.slice(0, 8)) + "..." : (ref5 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref5 === void 0 ? void 0 : ref5.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left",
                                                paddingRight: "10px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: (ref55 = (ref6 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref6 === void 0 ? void 0 : ref6.entity) !== null && ref55 !== void 0 ? ref55 : capitalizeFirstLetter((ref7 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref7 === void 0 ? void 0 : ref7.entity)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "40%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: ((ref8 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.detail) === null || ref9 === void 0 ? void 0 : ref9.oldValue) ? typeof ((ref10 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.detail) === null || ref11 === void 0 ? void 0 : ref11.oldValue) === "string" ? "".concat(t("oldValue: "), " ").concat((ref12 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.detail) === null || ref13 === void 0 ? void 0 : ref13.oldValue, " - ").concat(t("newValue: "), " ").concat((ref14 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.detail) === null || ref15 === void 0 ? void 0 : ref15.newValue) : "".concat(t("Change in ".concat((ref16 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.detail) === null || ref17 === void 0 ? void 0 : ref17.propertyName))) : t(auditingData.data[0].detail.entity)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "10%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: new Date((ref18 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[0]) === null || ref18 === void 0 ? void 0 : ref18.date).toLocaleDateString()
                                            })
                                        })
                                    ]
                                })
                            }),
                            (auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    height: "80px",
                                    backgroundColor: "#D8DBE3",
                                    borderRadius: "12px",
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    columns: 5,
                                    sx: {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "15px",
                                        width: "97%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    gap: 3,
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: (ref19 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.name) === null || ref20 === void 0 ? void 0 : ref20.slice(0, 1).toUpperCase()
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        children: ((ref21 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref21 === void 0 ? void 0 : ref21.name.length) > 8 ? ((ref22 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref22 === void 0 ? void 0 : ref22.name.slice(0, 8)) + "..." : (ref23 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref23 === void 0 ? void 0 : ref23.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left",
                                                paddingRight: "10px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: (ref56 = (ref24 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref24 === void 0 ? void 0 : ref24.entity) !== null && ref56 !== void 0 ? ref56 : capitalizeFirstLetter((ref25 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref25 === void 0 ? void 0 : ref25.entity)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "40%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: ((ref26 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.detail) === null || ref27 === void 0 ? void 0 : ref27.oldValue) ? typeof ((ref28 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.detail) === null || ref29 === void 0 ? void 0 : ref29.oldValue) === "string" ? "".concat(t("oldValue: "), " ").concat((ref30 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.detail) === null || ref31 === void 0 ? void 0 : ref31.oldValue, " - ").concat(t("newValue: "), " ").concat((ref32 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.detail) === null || ref33 === void 0 ? void 0 : ref33.newValue) : "".concat(t("Change in ".concat((ref34 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.detail) === null || ref35 === void 0 ? void 0 : ref35.propertyName))) : t(auditingData.data[1].detail.entity)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "10%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: new Date((ref36 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[1]) === null || ref36 === void 0 ? void 0 : ref36.date).toLocaleDateString()
                                            })
                                        })
                                    ]
                                })
                            }) : null,
                            (auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    height: "80px",
                                    backgroundColor: "#F1E9DB",
                                    borderRadius: "12px",
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    columns: 5,
                                    sx: {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "15px",
                                        width: "97%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    gap: 3,
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: (ref37 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.name) === null || ref38 === void 0 ? void 0 : ref38.slice(0, 1).toUpperCase()
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        children: ((ref39 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref39 === void 0 ? void 0 : ref39.name.length) > 8 ? ((ref40 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref40 === void 0 ? void 0 : ref40.name.slice(0, 8)) + "..." : (ref41 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref41 === void 0 ? void 0 : ref41.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "25%",
                                                textAlign: "left",
                                                paddingRight: "10px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                    text: (ref57 = (ref42 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref42 === void 0 ? void 0 : ref42.entity) !== null && ref57 !== void 0 ? ref57 : capitalizeFirstLetter((ref43 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref43 === void 0 ? void 0 : ref43.entity)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "40%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: ((ref44 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.detail) === null || ref45 === void 0 ? void 0 : ref45.oldValue) ? typeof ((ref46 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.detail) === null || ref47 === void 0 ? void 0 : ref47.oldValue) === "string" ? "".concat(t("oldValue: "), " ").concat((ref48 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.detail) === null || ref49 === void 0 ? void 0 : ref49.oldValue, " - ").concat(t("newValue: "), " ").concat((ref50 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.detail) === null || ref51 === void 0 ? void 0 : ref51.newValue) : "".concat(t("Change in ".concat((ref52 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.detail) === null || ref53 === void 0 ? void 0 : ref53.propertyName))) : t(auditingData.data[2].detail.entity)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sx: {
                                                width: "10%",
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: new Date((ref54 = auditingData === null || auditingData === void 0 ? void 0 : auditingData.data[2]) === null || ref54 === void 0 ? void 0 : ref54.date).toLocaleDateString()
                                            })
                                        })
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ var card_auditoria = (CardAuditoria);

// EXTERNAL MODULE: ./src/store/slices/grazingSlice.ts + 1 modules
var grazingSlice = __webpack_require__(62481);
// EXTERNAL MODULE: ./src/@core/utils/Cycles/get-cycles.ts
var get_cycles = __webpack_require__(29424);
;// CONCATENATED MODULE: ./src/views/dashboard/carbonfootprint-card/index.tsx









var pillTextSx = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "15px",
    backgroundColor: "rgba(25, 118, 210, 0.20)",
    mt: "24px",
    height: "40px",
    paddingLeft: "20px",
    paddingRight: "20px"
};
function CarbonfootprintCard(param) {
    var carbonFootprintEv = param.carbonFootprintEv, carbonFootprintHa = param.carbonFootprintHa, emission = param.emission, carbonSequestration = param.carbonSequestration, landId = param.landId, cycle = param.cycle;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "rodeos-card",
        sx: {
            minWidth: "250px",
            height: "495px",
            alignItems: "center",
            borderRadius: "20px",
            backgroundColor: "white !important"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: "card-medio",
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center"
                            },
                            className: "cards-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Carbon footprint"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#222",
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: 400,
                                letterSpacing: "-0.28px",
                                mb: "24px"
                            },
                            children: cycle.replace("_", "/")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                textAlign: "center",
                                mb: "30px",
                                padding: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "black",
                                        fontWeight: "700",
                                        fontSize: "40px",
                                        pr: 2
                                    },
                                    children: (0,number_format_asked/* numberFormatAsked */.I)(carbonFootprintEv)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "black",
                                                fontWeight: "500",
                                                fontSize: "18px",
                                                pr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                text: "kgCO2eq/kg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                color: "black",
                                                fontWeight: "700",
                                                fontSize: "12px",
                                                pr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                                text: "PV produced"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: pillTextSx,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Footprint [KgCO2eq/ha]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(carbonFootprintHa)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: pillTextSx,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Emission [KgCO2e/ha]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(emission)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: pillTextSx,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "black",
                                fontSize: "clamp(10px, 14px, 18px)",
                                textAlign: "left",
                                ml: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                text: "Sequestration [KgCO2e/ha]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "black",
                                    fontWeight: "600",
                                    fontSize: "18px"
                                },
                                children: (0,number_format_asked/* numberFormatAsked */.I)(carbonSequestration)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        w: "100%",
                        alignItems: "center",
                        mt: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        sx: {
                            color: "#213D36",
                            width: "123px",
                            padding: "8px, 12px, 8px, 12px",
                            fontSize: "16px",
                            fontWeight: 700,
                            borderRadius: "30px",
                            border: "3px solid #213D36",
                            mt: "auto"
                        },
                        onClick: function() {
                            return router.push("/lands/details/land/".concat(landId));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "See more"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/views/dashboard/dashboard-card-placer/index.tsx
























var DashboardCardPlacer = function(param) {
    var land = param.land, rainCardInfo = param.rainCardInfo, rodeoInfo = param.rodeoInfo;
    var currentDate = new Date();
    var currentDateLastYear = new Date(currentDate);
    currentDateLastYear.setFullYear(currentDate.getFullYear() - 1);
    var dispatch = (0,es/* useDispatch */.I0)();
    var authUser = (0,useFirebaseAuth/* default */.Z)(dispatch).authUser;
    var user = (0,es/* useSelector */.v9)(function(state) {
        return state.user;
    }).user;
    var setIsOpen = (0,tour_dist/* useTour */.rN)().setIsOpen;
    var functionCampo = (0,es/* useSelector */.v9)(function(state) {
        return state.report;
    }).functionCampo;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.dashboard;
    }), pastureGrowth = ref.pastureGrowth, detailedLoad = ref.detailedLoad, cardCarga = ref.cardCarga, auditingData = ref.auditingData;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.dp9Da1;
    }), emissionsDataCargaFina = ref1.emissionsDataCargaFina, carbonfootprintData = ref1.carbonfootprintData;
    var cycle = (0,get_campaign/* getCampaignStartingOnJuly */.i)(currentDate);
    var past_cycle = (0,get_campaign/* getCampaignStartingOnJuly */.i)(currentDateLastYear);
    var updatePastures = currentDate.getUTCDay() % 3 === 0;
    var productiveCycle = (0,get_cycles/* preferentCycleForModel */.c0)();
    var tif = functionCampo === null || functionCampo === void 0 ? void 0 : functionCampo.find(function(elemento) {
        return elemento.slugRaster === "".concat(land.id, "/").concat(productiveCycle, "/PRODUCTIVE_CAPACITY_VISUAL_RASTER.tif");
    });
    (0,react.useEffect)(function() {
        if (land && land.id) {
            if (updatePastures) {
                dispatch((0,grazingSlice/* postOnePastureGraph */.mc)({
                    landId: land.id,
                    cycle: cycle
                }));
            }
            dispatch((0,reportSlice/* fetchFuncionCampo */.$R)({
                id: land.id,
                cycle: productiveCycle
            }));
            dispatch((0,dashboard_slice/* fetchPastureGrowthData */.So)(land.id));
            dispatch((0,dashboard_slice/* fetchDetailedLoadData */._w)({
                landId: land.id,
                cycle: cycle
            }));
            dispatch((0,dp9_da1/* fetchEmissionsDataCargaFina */.v4)({
                landId: land.id,
                cycle: cycle
            }));
            dispatch((0,dp9_da1/* fetchCarbonfootprintData */.Vk)({
                landId: land.id,
                cycle: past_cycle
            }));
            dispatch((0,dashboard_slice/* fetchDataCarga */._P)(land.id));
            dispatch((0,dashboard_slice/* fetchAuditingData */.sM)(land.id));
        }
    }, [
        land
    ]);
    (0,react.useEffect)(function() {
        if (authUser && authUser.uid) {
            dispatch((0,userSlice/* fetchOneUser */.Gl)(authUser.uid));
        }
    }, [
        authUser
    ]);
    (0,react.useEffect)(function() {
        if (user && user.onBoarding !== true) setIsOpen(true);
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 5,
            sx: {
                mt: 2,
                width: "100%",
                alignContent: "flex-start"
            },
            children: [
                (land === null || land === void 0 ? void 0 : land.province) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WeatherCard, {
                        city: land.province
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: land && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadCard, {
                        land: land
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RainsCard, {
                        information: rainCardInfo,
                        landId: land.id,
                        status: land.state
                    })
                }),
                (land === null || land === void 0 ? void 0 : land.id) && tif && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDp5, {
                        landId: land.id,
                        percentage: tif.avgValue
                    })
                }),
                (land === null || land === void 0 ? void 0 : land.id) && pastureGrowth && pastureGrowth.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 6,
                    lg: 6,
                    md: 8,
                    sm: 12,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grass_growth, {
                        pastureGrowth: pastureGrowth,
                        landId: land.id
                    })
                }),
                rodeoInfo && rodeoInfo.totalHeads > 0 && rodeoInfo.differentCategories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RodeoCard, {
                        information: rodeoInfo,
                        landId: land.id,
                        status: land.state
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: cardCarga && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCarga, {
                        landId: land.id,
                        data: cardCarga
                    })
                }),
                (emissionsDataCargaFina === null || emissionsDataCargaFina === void 0 ? void 0 : emissionsDataCargaFina.kgCO2EqPV) && emissionsDataCargaFina.totalCO2eq && emissionsDataCargaFina.totalCO2EqPerMeanEv && emissionsDataCargaFina.kgCO2Ha && (land === null || land === void 0 ? void 0 : land.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmissionsCard, {
                        cycle: emissionsDataCargaFina.cycle,
                        kgCO2EqPV: emissionsDataCargaFina.kgCO2EqPV,
                        totalCO2eq: emissionsDataCargaFina.totalCO2eq,
                        totalCO2EqPerHead: emissionsDataCargaFina.totalCO2EqPerMeanEv,
                        kgCO2Ha: emissionsDataCargaFina.kgCO2Ha,
                        landId: land.id
                    })
                }),
                carbonfootprintData && (land === null || land === void 0 ? void 0 : land.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonfootprintCard, {
                        carbonFootprintEv: carbonfootprintData.carbonFootprintEv,
                        carbonFootprintHa: carbonfootprintData.carbonFootprintHa,
                        emission: carbonfootprintData.emission,
                        carbonSequestration: carbonfootprintData.carbonSequestration,
                        cycle: carbonfootprintData.cycle,
                        landId: land.id
                    })
                }),
                detailedLoad && (land === null || land === void 0 ? void 0 : land.id) && (land === null || land === void 0 ? void 0 : land.state) && !(detailedLoad.grADPV === 0 && detailedLoad.productionPerArea === 0 && detailedLoad.productionPerHead === 0 && detailedLoad.totalProduction === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 3,
                    lg: 3,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_production, {
                        detailedLoad: detailedLoad,
                        landId: land.id,
                        status: land.state
                    })
                }),
                (auditingData === null || auditingData === void 0 ? void 0 : auditingData.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xl: 6,
                    lg: 6,
                    md: 8,
                    sm: 12,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_auditoria, {
                        auditingData: auditingData
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var dashboard_card_placer = (DashboardCardPlacer);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Select/Select.js + 1 modules
var Select = __webpack_require__(77679);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(98649);
// EXTERNAL MODULE: ./src/store/slices/land-slice.ts
var land_slice = __webpack_require__(36947);
// EXTERNAL MODULE: ./src/store/slices/rainSlice.ts + 1 modules
var rainSlice = __webpack_require__(81749);
// EXTERNAL MODULE: ./src/store/slices/rodeoSlice.ts
var rodeoSlice = __webpack_require__(4667);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
// EXTERNAL MODULE: ./node_modules/mdi-material-ui/LandPlots.js
var LandPlots = __webpack_require__(13197);
// EXTERNAL MODULE: ./node_modules/mdi-material-ui/AccountOutline.js
var AccountOutline = __webpack_require__(99642);
// EXTERNAL MODULE: ./node_modules/mdi-material-ui/Ruler.js
var Ruler = __webpack_require__(2829);
;// CONCATENATED MODULE: ./src/views/dashboard/dashboard-nav/index.tsx













var DashboardNav = function(param) {
    var operationUnits = param.operationUnits;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(null), selectedUnit = ref1[0], setSelectedUnit = ref1[1];
    var ref2 = (0,react.useState)(false), refreshInput = ref2[0], setRefreshInput = ref2[1];
    var ref3 = (0,react.useState)(null), selectedLand = ref3[0], setSelectedLand = ref3[1];
    var ref4 = (0,react.useState)([]), landsOptions = ref4[0], setLandsOptions = ref4[1];
    var dashboard = (0,es/* useSelector */.v9)(function(state) {
        return state.dashboard;
    }).dashboard;
    (0,react.useEffect)(function() {
        dispatch((0,dashboard_slice/* fetchDashboardData */.a7)());
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        setRefreshInput(true);
        if (selectedUnit) {
            setLandsOptions(selectedUnit.lands || []);
        }
    }, [
        selectedUnit
    ]);
    (0,react.useEffect)(function() {
        if (selectedLand) {
            dispatch((0,land_slice/* fetchOneLand */.Rj)(selectedLand.id));
            dispatch((0,rainSlice/* fetchRainCardDashboard */.kZ)({
                landId: selectedLand.id
            }));
            dispatch((0,rodeoSlice/* fetchRodeosCardInfo */.TI)(selectedLand.id));
        }
    }, [
        selectedLand
    ]);
    (0,react.useEffect)(function() {
        if (operationUnits === null || operationUnits === void 0 ? void 0 : operationUnits.length) {
            var ref;
            var operationUnitWithData = operationUnits.find(function(operation) {
                var ref;
                return (ref = operation.lands) === null || ref === void 0 ? void 0 : ref.length;
            });
            var land = operationUnitWithData === null || operationUnitWithData === void 0 ? void 0 : (ref = operationUnitWithData.lands) === null || ref === void 0 ? void 0 : ref[0];
            setSelectedUnit(operationUnitWithData !== null && operationUnitWithData !== void 0 ? operationUnitWithData : null);
            setSelectedLand(land !== null && land !== void 0 ? land : null);
        }
    }, [
        operationUnits
    ]);
    var handleChangeOfOperationUnit = function(e) {
        setRefreshInput(false);
        var selectedId = e.target.value;
        var operationUnit = operationUnits.find(function(unit) {
            return unit.id === selectedId;
        });
        setSelectedUnit(operationUnit || null);
        if (operationUnit && operationUnit.lands && operationUnit.lands.length) {
            setSelectedLand(operationUnit.lands[0]);
        }
    };
    var handleChangeOfLand = function(e) {
        var selectedId = e.target.value;
        setSelectedLand(landsOptions.find(function(land) {
            return land.id === selectedId;
        }) || null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            borderBottom: 3,
            borderColor: "#D9D9D9",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: "black",
                            fontSize: "clamp(20px, 30px, 40px)",
                            fontWeight: "700"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                            text: "Dashboard"
                        })
                    }),
                    operationUnits.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                onChange: handleChangeOfOperationUnit,
                                sx: {
                                    mr: 5,
                                    padding: 0,
                                    "& .MuiSelect-select": {
                                        color: "black",
                                        bgcolor: "white",
                                        fontSize: "clamp(10px, 15px, 20px)",
                                        fontWeight: "700"
                                    },
                                    "& .MuiSvgIcon-root": {
                                        fill: "black"
                                    },
                                    position: "relative"
                                },
                                variant: "standard",
                                defaultValue: operationUnits[0].id,
                                IconComponent: KeyboardArrowDown/* default */.Z,
                                style: {
                                    color: "black"
                                },
                                disableUnderline: true,
                                children: operationUnits.map(function(unit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: unit.id,
                                        children: unit.name
                                    }, unit.id);
                                })
                            }),
                            (selectedUnit === null || selectedUnit === void 0 ? void 0 : (ref = selectedUnit.lands) === null || ref === void 0 ? void 0 : ref.length) && refreshInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                onChange: handleChangeOfLand,
                                sx: {
                                    "& .MuiSelect-select": {
                                        color: "black",
                                        bgcolor: "white",
                                        fontSize: "clamp(10px, 15px, 20px)",
                                        fontWeight: "700"
                                    },
                                    "& .MuiSvgIcon-root": {
                                        fill: "black"
                                    },
                                    position: "relative"
                                },
                                variant: "standard",
                                defaultValue: selectedUnit.lands[0].id,
                                IconComponent: KeyboardArrowDown/* default */.Z,
                                style: {
                                    color: "black"
                                },
                                disableUnderline: true,
                                children: selectedUnit.lands.map(function(land) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: land.id,
                                        children: land.name
                                    }, land.id);
                                })
                            }) : ""
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    alignItems: "center",
                    borderTop: "3px solid #D9D9D9",
                    padding: 2
                },
                children: [
                    (dashboard === null || dashboard === void 0 ? void 0 : dashboard.operationsUnits) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LandPlots/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "18px",
                                        fontWeight: 400,
                                        ml: "10px",
                                        mr: "10px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                        text: "Operation units: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "24px",
                                        fontWeight: 500
                                    },
                                    children: (0,number_format_asked/* numberFormatAsked */.I)(dashboard.operationsUnits) || null
                                })
                            ]
                        })
                    }),
                    (dashboard === null || dashboard === void 0 ? void 0 : dashboard.totalUsers) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "1px",
                                    height: "30px",
                                    backgroundColor: "#000",
                                    ml: "30px",
                                    mr: "30px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutline/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: "18px",
                                            fontWeight: 400,
                                            ml: "10px",
                                            mr: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Users: "
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: "24px",
                                            fontWeight: 500
                                        },
                                        children: (0,number_format_asked/* numberFormatAsked */.I)(dashboard.totalUsers) || null
                                    })
                                ]
                            })
                        ]
                    }),
                    (dashboard === null || dashboard === void 0 ? void 0 : dashboard.landsArea) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "1px",
                                    height: "30px",
                                    backgroundColor: "#000",
                                    ml: "30px",
                                    mr: "30px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ruler/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: "18px",
                                            fontWeight: 400,
                                            ml: "10px",
                                            mr: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                                            text: "Total has: "
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: "24px",
                                            fontWeight: 500
                                        },
                                        children: (0,number_format_asked/* numberFormatAsked */.I)(dashboard.landsArea) || null
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/views/dashboard/dashboard-no-land/index.tsx





var DashboardNoLand = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mt: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/No-land-image.png",
                alt: "Sin Campos",
                width: 370,
                height: 370
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    fontWeight: "700",
                    fontSize: "clamp(10px,30px,60px)",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                    text: "Create your land!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    fontWeight: "400",
                    fontSize: "clamp(10px,26px,60px)",
                    mt: 4,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                    text: "Create your land in Terratio to get its potential"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function() {
                    return router.push("/operation-units");
                },
                sx: {
                    bgcolor: "#213D36",
                    color: "white",
                    height: 40,
                    mt: 5,
                    width: 300
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translations/* default */.Z, {
                    text: "BEGIN"
                })
            })
        ]
    });
};
/* harmony default export */ var dashboard_no_land = (DashboardNoLand);

;// CONCATENATED MODULE: ./src/pages/home/index.tsx








var Home = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.operationUnit;
    }), operationUnitsAll = ref.operationUnitsAll, loadingOperationUnitsAll = ref.loading;
    var rainDashboarCardInformation = (0,es/* useSelector */.v9)(function(state) {
        return state.rain;
    }).rainDashboarCardInformation;
    var cardInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.rodeo;
    }).cardInfo;
    var land = (0,es/* useSelector */.v9)(function(state) {
        return state.land;
    }).land;
    var hidden = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    (0,react.useEffect)(function() {
        dispatch((0,operationUnitSlice/* fetchOperationUnit */.Am)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: hidden ? 15 : 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNav, {
                operationUnits: operationUnitsAll,
                land: land
            }),
            loadingOperationUnitsAll ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    mt: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: "100%",
                            height: "260px",
                            borderRadius: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: "100%",
                            height: "260px",
                            borderRadius: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: "100%",
                            height: "260px",
                            borderRadius: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: "100%",
                            height: "260px",
                            borderRadius: "20px"
                        }
                    })
                ]
            }) : land ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_card_placer, {
                land: land,
                rainCardInfo: rainDashboarCardInformation,
                rodeoInfo: cardInfo
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_no_land, {})
        ]
    });
};
Home.acl = {
    action: "read",
    subject: "home-page"
};
/* harmony default export */ var home = (Home);


/***/ }),

/***/ 91142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var GradientBox = function(param) {
    var colors = param.colors, tall = param.tall;
    var colores = colors.toString();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            borderRadius: "".concat(tall ? "5px" : "0px"),
            width: "90%",
            height: "".concat(tall !== null && tall !== void 0 ? tall : "2vw"),
            backgroundImage: "linear-gradient(to right, ".concat(colores, ")"),
            mb: 2
        },
        id: "gradient-colors"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientBox);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2196,6319,1265,6351,8402,2872,6647,7575,6127,8651,5936,2274,1854,7189,8697,1875,1228,9565,6104,9774,2888,179], function() { return __webpack_exec__(77183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);